import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/layout/Layout.jsx';
import Home from './pages/Home.jsx';
import MetakognitivTerapi from './pages/MetakognitivTerapi.jsx';
import Hypnose from './pages/Hypnose.jsx';
import Angst from './pages/Angst.jsx';
import Stress from './pages/Stress.jsx';
import Depression from './pages/Depression.jsx';
import OCD from './pages/OCD.jsx';
import ADHD from './pages/ADHD.jsx';
import Autisme from './pages/Autisme.jsx';
import Panikangst from './pages/Panikangst.jsx';
import Borderline from './pages/Borderline.jsx';
import Traume from './pages/Traume.jsx';
import Soevnproblemer from './pages/Soevnproblemer.jsx';
import Tankemylder from './pages/Tankemylder.jsx';
import OnlineSessioner from './pages/OnlineSessioner.jsx';
import Behandlinger from './pages/Behandlinger.jsx';
import OmLars from './pages/OmLars.jsx';
import SeHvordanJegArbejder from './pages/SeHvordanJegArbejder.jsx';
import Rygestop from './pages/Rygestop.jsx';
import GeneraliseretAngst from './pages/GeneraliseretAngst.jsx';
import Priser from './pages/Priser.jsx';
import FAQ from './pages/FAQ.jsx';
import Kontakt from './pages/Kontakt.jsx';
import BookTid from './pages/BookTid.jsx';
import Privatlivspolitik from './pages/Privatlivspolitik.jsx';
import Parterapi from './pages/Parterapi.jsx';
import SocialAngst from './pages/SocialAngst.jsx';
import Helbredsangst from './pages/Helbredsangst.jsx';
import Eksamensangst from './pages/Eksamensangst.jsx';
import SorgOgTab from './pages/SorgOgTab.jsx';
import Flyskraek from './pages/Flyskraek.jsx';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } else {
        const timer = setTimeout(() => {
          const el = document.getElementById(id);
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
        return () => clearTimeout(timer);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/metakognitiv-terapi" element={<Layout><MetakognitivTerapi /></Layout>} />
          <Route path="/hypnose" element={<Layout><Hypnose /></Layout>} />
          <Route path="/angst" element={<Layout><Angst /></Layout>} />
          <Route path="/stress" element={<Layout><Stress /></Layout>} />
          <Route path="/depression" element={<Layout><Depression /></Layout>} />
          <Route path="/ocd" element={<Layout><OCD /></Layout>} />
          <Route path="/adhd" element={<Layout><ADHD /></Layout>} />
          <Route path="/autismevenlig-terapi" element={<Layout><Autisme /></Layout>} />
          <Route path="/panikangst" element={<Layout><Panikangst /></Layout>} />
          <Route path="/borderline" element={<Layout><Borderline /></Layout>} />
          <Route path="/traume" element={<Layout><Traume /></Layout>} />
          <Route path="/soevnproblemer" element={<Layout><Soevnproblemer /></Layout>} />
          <Route path="/tankemylder" element={<Layout><Tankemylder /></Layout>} />
          <Route path="/online-sessioner" element={<Layout><OnlineSessioner /></Layout>} />
          <Route path="/behandlinger" element={<Layout><Behandlinger /></Layout>} />
          <Route path="/om-lars" element={<Layout><OmLars /></Layout>} />
          <Route path="/om-lars/se-hvordan-jeg-arbejder" element={<Layout><SeHvordanJegArbejder /></Layout>} />
          <Route path="/behandlinger/rygestop" element={<Layout><Rygestop /></Layout>} />
          <Route path="/generaliseret-angst" element={<Layout><GeneraliseretAngst /></Layout>} />
          <Route path="/priser" element={<Layout><Priser /></Layout>} />
          <Route path="/faq" element={<Layout><FAQ /></Layout>} />
          <Route path="/kontakt" element={<Layout><Kontakt /></Layout>} />
          <Route path="/bestil-tid" element={<Layout><BookTid /></Layout>} />
          <Route path="/privatlivspolitik" element={<Layout><Privatlivspolitik /></Layout>} />
          <Route path="/parterapi" element={<Layout><Parterapi /></Layout>} />
          <Route path="/social-angst" element={<Layout><SocialAngst /></Layout>} />
          <Route path="/helbredsangst" element={<Layout><Helbredsangst /></Layout>} />
          <Route path="/eksamensangst-praestationsangst" element={<Layout><Eksamensangst /></Layout>} />
          <Route path="/sorg-og-tab" element={<Layout><SorgOgTab /></Layout>} />
          <Route path="/flyskraek" element={<Layout><Flyskraek /></Layout>} />
          <Route path="/flyskraek/" element={<Layout><Flyskraek /></Layout>} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
